<template>
  <transition name="msg-fade">
    <div class="message" :class="type" v-show="visible">
      <span class="icon"></span>
      <p class="content">{{ content }}</p>
      <span class="delete-icon" @click="onCancle"></span>
    </div>
  </transition>
</template>  
 
<script>
const Msg = {
  name: "message",
  data() {
    return {
      visible: false,
      type: "",
      content: "",
    };
  },
  install(Vue) {
    Vue.prototype.$message = (config) => {
      //通过原型注册一个方法
      const MessageConstructor = Vue.extend(Msg); //生成一个Vue子类，子类就是这个组件
      const instance = new MessageConstructor({ data: config }); //生成该子类的实例
      instance.vm = instance.$mount(); //将该实例手动挂载
      document.body.appendChild(instance.vm.$el); //将实例挂载到body上
      instance.vm.visible = true;
    };
  },
  watch: {
    visible(v) {
      if (v) {
        setTimeout(() => {
          this.onClose();
        }, 3000);
      }
    },
  },
  methods: {
    onClose() {
      this.visible = false;
      this.$el.parentNode.removeChild(this.$el);
    },
    show() {
      this.visible = true;
    },
    onCancle() {
      if (this.cancelBtn) {
        this.cancelBtn.apply(this.content);
      }
      this.onClose();
    },
  },
};
export default Msg;
</script>
 
<style scoped lang='less'>
.message {
  position: fixed;
  right: 20px;
  top: 50px;
  background: rgba(0, 0, 0, 0.6);
  z-index: 999999;
  width: 288px;
  min-height: 40px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  padding: 0 16px;

  .icon {
    width: 14px;
    height: 14px;
    margin-right: 10px;
    background: url(../assets/images/icon-notice.svg) no-repeat;
    background-size: 100% 100%;
  }

  &.success {
    background: #ebf8f2;
    border: 1px solid #06AE63;
    border-radius: 4px;

    .icon {
      background: url(../assets/images/icon-correct.svg) no-repeat;
    }
  }

  &.warn {
    background: #fffaeb;
    border: 1px solid #fccca7;
    border-radius: 4px;
  }

  &.error {
    background: #fef3eb;
    border: 1px solid #FF3B2F;
    border-radius: 4px;
    .icon {
      background: url(../assets/images/icon-error.svg) no-repeat;
    }
  }

  .content {
    flex: 1;
    max-width: 200px;
    word-break: break-all;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.65);
    letter-spacing: 0;
    line-height: 36px;
    align-self: flex-start;
  }

  .delete-icon {
    margin-left: auto;
    width: 14px;
    height: 14px;
    font-size: 18px;
    cursor: pointer;
    color: #000;
    opacity: 0.43;
    background: url(../assets/images/delete.svg) no-repeat 0 0;
    background-size: 100% 100%;
  }
}

.msg-fade-enter-active {
  animation: alert-fade-in 0.3s;
}

.msg-fade-leave-active {
  animation: alert-fade-out 0.3s;
}

@keyframes alert-fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes alert-fade-out {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
</style>
